export default "__VITE_PUBLIC_ASSET__449d3ba3__"